const files = require.context('.', true, /\.js$/)
const module = {}

const validateAnswer = function (errors, vm, showTip) {
  if (this.valid === false) {
    return true
  }
  const descList = this.descList
  if (descList) {
    return !descList.some(desc => vm.$util.isNull(desc.value))
  }
  return !vm.$util.isNull(this.value)
}

const validate = function (vm, showTip) {
  const errors = []
  return {
    result: validateAnswer.call(this, errors, vm),
    errors
  }
}

files.keys().forEach((key) => {
  if (key === './index.js' || key === './config.js' || key === './logic.js' || key === './answer.js' || key === './validate.js' ||
  key === './answerValidate.js') {
    return
  }
  const moduleName = key.substring(key.indexOf('/') + 1, key.lastIndexOf('/'))
  if (key.indexOf('answerValidate') > -1) {
    const { validateAnswer, validate } = files(key).default
    module[moduleName] = {
      validateAnswer,
      validate
    }
  } else if (!module[moduleName]) {
    module[moduleName] = {
      validate
    }
  }
})
export default module



// WEBPACK FOOTER //
// ./src/components/editor/answerValidate.js